// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
// import lodash from 'lodash'
import _ from 'lodash'
import ElementUI from 'element-ui'

import './assets/style/base.css'
import './assets/style/index.css'
import './assets/style/page.css'
import './assets/font/iconfont'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import 'element-ui/lib/theme-chalk/index.css'

import store from './store'
import {getImgPath} from './util'

Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI, { size: 'small' })
// Vue.use(lodash)
Vue.config.productionTip = false
Vue.prototype._ = _
function getToken () {
  // return window.localStorage.getItem('labToken', '')
  return '6IWTTHsvYTHAraxczmZV8MJNvsRDFhzERr+EJH1zCiT+I3loXzz7wX034OEOfGJJ'
}
Vue.prototype.$axios = axios
Vue.prototype.$axios.interceptors.request.use(
  config => {
    config.headers['Authorization'] = getToken()
    // config.headers['token'] = '6IWTTHsvYTHAraxczmZV8MJNvsRDFhzERr+EJH1zCiT+3loXzz7wX0340EOfGJJ'
    return config
  }, error => {
    return Promise.reject(error).catch(() => {})
  }
)
Vue.prototype.$getImgPath = getImgPath

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js